export const FIND_PAYMENT_METHODS = "FIND_PAYMENT_METHODS"
export const FIND_PAYMENT_METHODS_SUCCESS = "FIND_PAYMENT_METHODS_SUCCESS"

export const FIND_PAYMENT_METHODS_API_ERROR = "FIND_PAYMENT_METHODS_API_ERROR"
